import PauseTransactionsDialog from './PauseTransactionsDialog';

export default PauseTransactionsDialog;
